
import { defineComponent, ref } from 'vue';
import ProgressSpinner from 'primevue/progressspinner';
import { getOrderNest, getCart, getContact } from '@/composables/data-explorer/DataExplorer';
import { DataExplorerDataType } from '@/types';
import { useStore } from '@/store';
import { useI18n } from 'vue-i18n';
import { showToastError } from '@/helpers';

export default defineComponent({
  name: 'DataExplorerLink',

  components: {
    ProgressSpinner,
  },

  props: {
    id: {
      type: [Number, String],
      required: true,
    },

    label: {
      type: String,
      required: false,
      default: '',
    },

    value: {
      type: String,
      required: true,
    },

    className: {
      type: String,
      required: false,
      default: '',
    },

    type: {
      type: String,
      required: false,
      default: DataExplorerDataType.CONTACT_FILE,
    },

    showIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    const { t } = useI18n();
    const store = useStore();

    const loading = ref(false);

    const openFile = async () => {
      try {
        loading.value = true;
        const openedDatas = store.getters['dataExplorer/getOpenedDatas'];

        const mapGet: Record<string, any> = {
          [DataExplorerDataType.CONTACT_FILE]: {
            compareData: (openedData: any) => openedData.generalInformation.data.idShopContact === props.id,
            getData: async () => getContact(props.id as number),
            storeAction: (data: any) => store.dispatch('dataExplorer/openContactFile', { contact: data }),
          },

          [DataExplorerDataType.ORDER_FILE]: {
            // props.id = id_shop_order (cf. OrdersV2 :id="data.id" + getOrderNest filtre `id`)
            // → comparer sur idShopOrder, pas idOrder (= id_order marchand).
            compareData: (openedData: any) => openedData.idShopOrder === props.id,
            getData: async () => getOrderNest(props.id as number),
            storeAction: (data: any) => store.dispatch('dataExplorer/openOrderFile', { order: data }),
          },

          [DataExplorerDataType.CART_FILE]: {
            compareData: (openedData: any) => openedData.idCart === props.id,
            getData: async () => getCart(props.id as string),
            storeAction: (data: any) => store.dispatch('dataExplorer/openCartFile', { cart: data }),
          },
        };

        let data = openedDatas
          .filter((openedData: any) => openedData.dataType === props.type)
          .find((openedData: any) => mapGet[props.type].compareData(openedData));

        if (!data) {
          data = await mapGet[props.type].getData();
        }

        if (data) {
          mapGet[props.type].storeAction(data);
        } else {
          await showToastError(t('dataExplorer.noDataForThisFile'));
        }
      } catch (err) {
        await showToastError(t('dataExplorer.noDataForThisFile'));
      } finally {
        loading.value = false;
      }
    };

    return {
      loading,
      openFile,
    };
  },
});
